
import React from 'react';
import './DashboardButton.css';  // Assuming you will create a separate CSS file

const DashboardButton = ({ icon, title, subtitle, onClick, active }) => {
    return (
        <div className="dashboard-button" onClick={onClick}>
            <h2 className="button-title">{title}</h2>
            <p className="button-subtitle">{subtitle}</p>
            {icon && <img src={icon} alt={title}  className="button-icon" />}
        </div>
    );
};

export default DashboardButton;